import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "hintMessage", "error", "value", "defaultValue", "onChange", "onClear", "onConfirm", "onBlur", "formatter", "calendarProps", "disabledDays", "bgColor"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/DatePicker/SingleDatePicker.js",
  _this = this;
import React from 'react';
import DatePicker from './DatePicker';
import { noop } from '../../helpers';
import { SingleDatePickerCalendar } from './calendarViews';
import supportedFormats from './supportedFormats';
var SingleDatePicker = function SingleDatePicker(_ref) {
  var label = _ref.label,
    hintMessage = _ref.hintMessage,
    error = _ref.error,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    onClear = _ref.onClear,
    onConfirm = _ref.onConfirm,
    onBlur = _ref.onBlur,
    formatter = _ref.formatter,
    _ref$calendarProps = _ref.calendarProps;
  _ref$calendarProps = _ref$calendarProps === void 0 ? {} : _ref$calendarProps;
  var availableDays = _ref$calendarProps.availableDays,
    _ref$calendarProps$de = _ref$calendarProps.defaultOptions,
    defaultOptions = _ref$calendarProps$de === void 0 ? {} : _ref$calendarProps$de,
    disabledDays = _ref.disabledDays,
    bgColor = _ref.bgColor,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(DatePicker, {
    label: label,
    hintMessage: hintMessage,
    error: error,
    "data-testid": rest['data-testid'],
    value: value,
    defaultValue: defaultValue,
    formatter: formatter,
    bgColor: bgColor,
    onBlur: onBlur,
    renderCalendar: function renderCalendar(props) {
      return /*#__PURE__*/React.createElement(SingleDatePickerCalendar, _extends({}, props, {
        calendarProps: {
          availableDays: availableDays,
          defaultOptions: defaultOptions
        },
        datePickerProps: {
          onChange: onChange,
          onClear: onClear,
          onConfirm: onConfirm
        },
        formatter: formatter,
        disabledDays: disabledDays,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 9
        }
      }));
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  });
};
SingleDatePicker.defaultProps = {
  onChange: noop,
  onClear: noop,
  onConfirm: noop,
  formatter: supportedFormats['dd MMM yyyy']
};
export default SingleDatePicker;